import Router from 'next/router';
import * as React from 'react';
import { getAuthFromContext } from '@auth/business/auth.utils';
import { SignUpProLayout } from '@auth/components/SignUpProLayout/SignUpProLayout.component';
import { defaultNamespaces } from '@utils/strings';
import { castUrlParamToString, redirect, urlEnum } from '@utils/url';
import { PlcNextPage, PlcNextPageContext } from 'features/business/app.types';

export type InscriptionProPageProps = { teamInviteToken?: string; inviteEmail?: string };

const Inscription: PlcNextPage<Partial<InscriptionProPageProps>> = ({ teamInviteToken, inviteEmail }) => {
  return <SignUpProLayout inviteEmail={inviteEmail} teamInviteToken={teamInviteToken} />;
};

Inscription.getInitialProps = async (ctx: PlcNextPageContext) => {
  const { activationToken, email } = ctx.query;
  const teamInviteToken = castUrlParamToString(activationToken);
  const inviteEmail = castUrlParamToString(email);
  const pageDefaultState = { namespacesRequired: defaultNamespaces };

  const { isAuthenticated } = getAuthFromContext(ctx);
  if (isAuthenticated) {
    redirect({
      Router,
      ctx,
      location: urlEnum.subscriptionPro,
    });
    return pageDefaultState;
  }

  return { ...pageDefaultState, inviteEmail, teamInviteToken };
};

export default Inscription;
